import { render, staticRenderFns } from "./LinkEmpresarial.vue?vue&type=template&id=c4458e2e"
import script from "./LinkEmpresarial.vue?vue&type=script&lang=js"
export * from "./LinkEmpresarial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports